import React, { useEffect, useMemo, useState } from 'react';
import { Button, Card, CardBody, Col, Container, Input, Label, Row } from 'reactstrap';
import Breadcrumbs from '../../components/Common/Breadcrumb';
import FormModal from '../components/FormModal';
import LoadingSpiner from '../components/LoadingSpiner';
import {
  capitalizeWords,
  formatPhoneNumber,
  formatPrice,
} from '../components/capitalizeFunction';
import { deleteButton } from '../components/AlerteModal';
import {
  useDeletePaiement,
  usePagignationPaiements,
} from '../../Api/queriesPaiement';
import PaiementForm from './PaiementForm';
import ReçuPaiement from './ReçuPaiement';
import {
  connectedUserBoutique,
  connectedUserRole,
} from '../Authentication/userInfos';
import ListPagination from '../components/ListPagination';

export default function PaiementsListe() {
  const [page, setPage] = useState(1);
  const limit = 35;
  const [form_modal, setForm_modal] = useState(false);
  const { mutate: deletePaiement, isDeleting } = useDeletePaiement();
  const [paiementToUpdate, setPaiementToUpdate] = useState(null);
  const [formModalTitle, setFormModalTitle] = useState('Nouveau Paiement');
  const [selectedPaiement, setSelectedPaiement] = useState(null);
  const [show_modal, setShow_modal] = useState(false);

  // State de Recherche
  const [searchTerm, setSearchTerm] = useState('');
  const [filterReliqua, setFilterReliqua] = useState(false);
  const [todayPaiement, setTodayPaiement] = useState(false);
  const [selectedBoutique, setSelectedBoutique] = useState(null);

  /**
   * -----------------------------
   * MODIF (recherche pro + pagination cohérente + cache)
   * -----------------------------
   * Avant: filtrage côté frontend (search/boutique/reliqua/today) sur la page courante.
   * Maintenant:
   * - debounce 300ms sur searchTerm
   * - on passe search/boutique/reliqua/today au backend (filtre AVANT pagination)
   * - le cache React Query est isolé par queryKey (corrigé dans le hook)
   */
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTerm);
  useEffect(() => {
    const t = setTimeout(() => setDebouncedSearchTerm(searchTerm), 300);
    return () => clearTimeout(t);
  }, [searchTerm]);

  useEffect(() => {
    setPage(1);
  }, [debouncedSearchTerm, selectedBoutique, filterReliqua, todayPaiement]);

  const {
    data: paiementsData,
    isLoading,
    error,
  } = usePagignationPaiements(
    page,
    limit,
    debouncedSearchTerm,
    selectedBoutique,
    filterReliqua,
    todayPaiement
  );

  const filterSearchPaiement = useMemo(
    () => paiementsData?.results?.data || [],
    [paiementsData]
  );

  // Total de commandes
  const sumTotalAmount = filterSearchPaiement?.reduce((curr, item) => {
    return (curr += item?.totalAmount);
  }, 0);

  // Total Payés
  const sumTotalPaye = filterSearchPaiement?.reduce((curr, item) => {
    return (curr += item?.totalPaye);
  }, 0);

  const sumTotalRestant = sumTotalAmount - sumTotalPaye;

  const hasActiveFilters =
    Boolean(searchTerm) ||
    filterReliqua ||
    todayPaiement ||
    selectedBoutique != null;

  const resetFilters = () => {
    setSearchTerm('');
    setFilterReliqua(false);
    setTodayPaiement(false);
    setSelectedBoutique(null);
  };

  // Ouverture de Modal Form
  function tog_form_modal() {
    setForm_modal(!form_modal);
  }

  // Ouverture de Modal Reçu Paiement
  function tog_show_modal() {
    setShow_modal(!show_modal);
  }
  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <Breadcrumbs title='Transaction' breadcrumbItem='Paiements' />

          {/* -------------------------- */}
          <FormModal
            form_modal={form_modal}
            setForm_modal={setForm_modal}
            tog_form_modal={tog_form_modal}
            modal_title={formModalTitle}
            size='md'
            bodyContent={
              <PaiementForm
                paiementToEdit={paiementToUpdate}
                tog_form_modal={tog_form_modal}
              />
            }
          />

          {/* -------------------- */}
          <ReçuPaiement
            show_modal={show_modal}
            tog_show_modal={tog_show_modal}
            selectedPaiementID={selectedPaiement}
          />
          {/* -------------------- */}
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <div id='paiementsList'>
                    {/* Barre outils + filtres + synthèse */}
                    <div className='border rounded-3 p-3 mb-3 bg-light'>
                      <Row className='g-3 align-items-end'>
                        <Col xl={3} lg={4} md={6}>
                          <Button
                            color='info'
                            className='add-btn w-100'
                            id='create-btn'
                            onClick={() => {
                              setPaiementToUpdate(null);
                              setFormModalTitle('Nouveau Paiement');
                              tog_form_modal();
                            }}
                          >
                            <i className='fas fa-dollar-sign align-center me-1'></i>
                            Ajouter un Paiement
                          </Button>
                        </Col>

                        <Col xl={3} lg={4} md={6}>
                          <Label
                            htmlFor='filterBoutiquePaiement'
                            className='fw-semibold mb-1'
                          >
                            Boutique
                          </Label>
                          <div className='d-flex gap-2'>
                            <Input
                              id='filterBoutiquePaiement'
                              type='select'
                              bsSize='sm'
                              value={selectedBoutique ?? ''}
                              onChange={(e) => {
                                const v = e.target.value;
                                setSelectedBoutique(
                                  v === '' ? null : Number(v)
                                );
                              }}
                              className='border border-dark flex-grow-1'
                              style={{ cursor: 'pointer' }}
                            >
                              <option value=''>Toutes les boutiques</option>
                              <option value={connectedUserBoutique ?? 0}>
                                {connectedUserBoutique ?? 0} — Ma boutique
                              </option>
                              <optgroup label='Raccourcis'>
                                <option value='1'>Boutique 1</option>
                                <option value='2'>Boutique 2</option>
                              </optgroup>
                            </Input>
                            <Input
                              type='number'
                              bsSize='sm'
                              className='border border-dark'
                              placeholder='N°'
                              title='Numéro de boutique'
                              style={{ maxWidth: '90px' }}
                              value={selectedBoutique ?? ''}
                              onChange={(e) => {
                                const raw = e.target.value;
                                setSelectedBoutique(
                                  raw === '' ? null : Number(raw)
                                );
                              }}
                            />
                          </div>
                        </Col>

                        <Col xl={4} lg={4} md={8}>
                          <Label
                            htmlFor='filterSearchPaiement'
                            className='fw-semibold mb-1'
                          >
                            Recherche
                          </Label>
                          <div className='d-flex gap-2'>
                            <Input
                              id='filterSearchPaiement'
                              type='text'
                              bsSize='sm'
                              className='border border-dark'
                              placeholder='Client, adresse, montant…'
                              value={searchTerm}
                              onChange={(e) => setSearchTerm(e.target.value)}
                            />
                            {searchTerm !== '' && (
                              <Button
                                color='danger'
                                size='sm'
                                outline
                                title='Effacer la recherche'
                                onClick={() => setSearchTerm('')}
                              >
                                <i className='fas fa-times'></i>
                              </Button>
                            )}
                          </div>
                        </Col>

                        <Col xl={2} lg={12} className='text-lg-end'>
                          {hasActiveFilters && (
                            <Button
                              color='secondary'
                              size='sm'
                              outline
                              className='w-100 w-md-auto'
                              onClick={resetFilters}
                            >
                              <i className='ri-filter-off-line me-1'></i>
                              Réinitialiser
                            </Button>
                          )}
                        </Col>
                      </Row>

                      <Row className='g-3 mt-1 align-items-stretch'>
                        <Col lg={5}>
                          <Label className='fw-semibold mb-2 d-block'>
                            Filtres rapides
                          </Label>
                          <div className='d-flex flex-wrap gap-2'>
                            <Button
                              color={filterReliqua ? 'danger' : 'light'}
                              size='sm'
                              className={
                                filterReliqua
                                  ? 'text-white'
                                  : 'border border-secondary text-dark'
                              }
                              onClick={() => setFilterReliqua(!filterReliqua)}
                            >
                              <i className='ri-money-dollar-circle-line me-1'></i>
                              Impayés
                            </Button>
                            <Button
                              color={todayPaiement ? 'warning' : 'light'}
                              size='sm'
                              className={
                                todayPaiement
                                  ? 'text-white'
                                  : 'border border-secondary text-dark'
                              }
                              onClick={() => setTodayPaiement(!todayPaiement)}
                            >
                              <i className='ri-calendar-line me-1'></i>
                              Aujourd&apos;hui
                            </Button>
                          </div>
                        </Col>

                        {!isLoading && !error && (
                          <Col lg={7}>
                            <Label className='fw-semibold mb-2 d-block'>
                              Synthèse (page courante)
                            </Label>
                            <Row className='g-2'>
                              <Col xs={4}>
                                <div className='border rounded bg-white p-2 text-center h-100'>
                                  <div className='text-muted small'>
                                    Total facture
                                  </div>
                                  <div className='text-info fw-bold'>
                                    {formatPrice(sumTotalAmount)} F
                                  </div>
                                </div>
                              </Col>
                              <Col xs={4}>
                                <div className='border rounded bg-white p-2 text-center h-100'>
                                  <div className='text-muted small'>Payé</div>
                                  <div className='text-success fw-bold'>
                                    {formatPrice(sumTotalPaye)} F
                                  </div>
                                </div>
                              </Col>
                              <Col xs={4}>
                                <div className='border rounded bg-white p-2 text-center h-100'>
                                  <div className='text-muted small'>
                                    Reliquat
                                  </div>
                                  <div className='text-danger fw-bold'>
                                    {formatPrice(sumTotalRestant)} F
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </Col>
                        )}
                      </Row>
                    </div>

                    <ListPagination
                      page={paiementsData?.results?.page ?? page}
                      totalPages={paiementsData?.results?.totalPages ?? 1}
                      onPageChange={setPage}
                      className='mt-2 mb-2'
                    />
                    {error && (
                      <div className='text-danger text-center'>
                        Erreur de chargement des données
                      </div>
                    )}
                    {isLoading && <LoadingSpiner />}

                    <div className='table-responsive table-card mt-3 mb-1'>
                      {filterSearchPaiement?.length === 0 && (
                        <div className='text-center text-mutate'>
                          Aucun paiement trouver !
                        </div>
                      )}
                      {!error &&
                        !isLoading &&
                        filterSearchPaiement?.length > 0 && (
                          <table
                            className='table align-middle table-nowrap table-hover'
                            id='paiementTable'
                          >
                            <thead className='table-light text-center align-middle'>
                              <tr>
                                <th style={{ minWidth: '110px' }}>
                                  Date
                                </th>
                                <th>Client</th>
                                <th>Contact / Livraison</th>
                                <th>
                                  Facture
                                  <div className='small fw-normal text-muted'>
                                    Montant
                                  </div>
                                </th>
                                <th>
                                  Payé
                                  <div className='small fw-normal text-muted'>
                                    Méthode
                                  </div>
                                </th>
                                <th>
                                  Reliquat
                                </th>
                                <th>Réduction</th>
                                <th style={{ width: '120px' }}>Actions</th>
                              </tr>
                            </thead>

                            <tbody className='list form-check-all text-center'>
                              {filterSearchPaiement?.length > 0 &&
                                filterSearchPaiement?.map((paiement) => (
                                  <tr key={paiement?._id}>
                                    <th scope='row'>
                                      {new Date(
                                        paiement?.paiementDate
                                      ).toLocaleDateString()}
                                    </th>
                                    <td
                                      className='id'
                                      style={{ display: 'none' }}
                                    ></td>
                                    <td>
                                      {capitalizeWords(
                                        paiement?.commande?.fullName
                                      )}
                                    </td>

                                    <td>
                                      <p>
                                        {capitalizeWords(
                                          paiement?.commande?.adresse
                                        )}
                                      </p>{' '}
                                      {formatPhoneNumber(
                                        paiement?.commande?.phoneNumber
                                      ) || '----'}
                                    </td>

                                    <td>
                                      {formatPrice(paiement?.totalAmount)}
                                      {' F '}
                                    </td>
                                    <td>
                                      {formatPrice(paiement?.totalPaye)}
                                      {' F '}
                                      <p className='text-warning'>
                                        {capitalizeWords(paiement?.methode)}
                                      </p>
                                    </td>
                                    <td>
                                      {paiement?.totalAmount -
                                        paiement?.totalPaye >
                                      0 ? (
                                        <span className='text-danger'>
                                          {' '}
                                          {formatPrice(
                                            paiement?.totalAmount -
                                              paiement?.totalPaye
                                          )}
                                          {' F '}
                                        </span>
                                      ) : (
                                        <span>
                                          {' '}
                                          {formatPrice(
                                            paiement?.totalAmount -
                                              paiement?.totalPaye
                                          )}
                                          {' F '}
                                        </span>
                                      )}
                                    </td>
                                    <td className='text-warning'>
                                      {formatPrice(paiement?.reduction)} F
                                    </td>

                                    <td>
                                      {isDeleting && <LoadingSpiner />}
                                      {!isDeleting && (
                                        <div className='d-flex gap-2'>
                                          <div>
                                            <button
                                              className='btn btn-sm btn-secondary show-item-btn'
                                              data-bs-toggle='modal'
                                              data-bs-target='#showModal'
                                              onClick={() => {
                                                setSelectedPaiement(
                                                  paiement?._id
                                                );
                                                tog_show_modal();
                                              }}
                                            >
                                              <i className='bx bx-show align-center text-white'></i>
                                            </button>
                                          </div>
                                          {connectedUserRole === 'admin' &&
                                            connectedUserBoutique ===
                                              paiement.user.boutique && (
                                              <div className='d-flex'>
                                                <div className='edit mx-2'>
                                                  <button
                                                    className='btn btn-sm btn-success edit-item-btn'
                                                    onClick={() => {
                                                      setFormModalTitle(
                                                        'Modifier les données'
                                                      );
                                                      setPaiementToUpdate(
                                                        paiement
                                                      );
                                                      tog_form_modal();
                                                    }}
                                                  >
                                                    <i className='ri-pencil-fill text-white'></i>
                                                  </button>
                                                </div>
                                                <div className='remove'>
                                                  <button
                                                    className='btn btn-sm btn-danger remove-item-btn'
                                                    onClick={() => {
                                                      deleteButton(
                                                        paiement?._id,
                                                        `Paiement de ${formatPrice(
                                                          paiement?.totalAmount
                                                        )} F
                                                    `,
                                                        deletePaiement
                                                      );
                                                    }}
                                                  >
                                                    <i className='ri-delete-bin-fill text-white'></i>
                                                  </button>
                                                </div>
                                              </div>
                                            )}
                                        </div>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                            </tbody>
                          </table>
                        )}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}
